





































































































































import { FMessageBox } from '@fkui/vue';
import Vue from 'vue';

export default Vue.extend({
    name: 'BtResultat',
    components: {
        FMessageBox,
    },
    props: {
        isSambo: {
            type: Boolean,
            required: true,
            default: false,
        },
        isSamboSa: {
            type: Boolean,
            required: true,
            default: false,
        },
        manadsbelopp1: {
            type: Number,
            required: false,
            default: -1,
        },
        manadsbelopp2: {
            type: Number,
            required: false,
            default: -1,
        },
    },
    data() {
        return {
            id: 'resultatRubrik',
        };
    },
    methods: {
        roundToNearest100(number: number): number {
            return Math.floor(number / 100) * 100;
        },
        tusentalsavgransare(nummer: number): string {
            return nummer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        },
        avgransareMedAvrundning(nummer: number): string {
            return this.tusentalsavgransare(this.roundToNearest100(nummer));
        },
        checkManadsBelopp(): number {
            if (this.manadsbelopp2 > 0) {
                return this.manadsbelopp2;
            } else {
                return 0;
            }
        },
        manadsBeloppDelat() {
            return this.tusentalsavgransare(this.roundToNearest100(this.manadsbelopp1 + this.checkManadsBelopp()) / 2);
        },
    },
});
